import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import './styles/Projects.css';
import { projectMeta } from "./projectMeta";
import SearchBar from "./components/SearchBar";
import FilterList from "./components/Filters";

import Drawer from "./components/Drawer";

export default function Projects() {
  const [search, setSearch] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [sortNewest, setSortNewest] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const [filtered, setFiltered] = useState(projectMeta);

  const clearFilters = () => {
    setSelectedTags([]);
    setSortNewest(true);
    setSearch('');
  };

  // const timeSort = () => {
  //   setSortNewest(!sortNewest);

  // }
  useEffect(() => {
    document.title = 'Projects';
    setIsOpen(false);
    const timeout = setTimeout(() => {
      const filteredProjects = projectMeta
        .filter(
          (p) =>
            p.title.toLowerCase().includes(search.toLowerCase()) &&
            (selectedTags.length === 0 ||
              selectedTags.every((tag) => p.tags.includes(tag)))
        )
        .sort((a, b) => (sortNewest ? b.year - a.year : a.year - b.year));

      setFiltered(filteredProjects);
      setIsOpen(true);
    }, 400);

    return () => clearTimeout(timeout);
  }, [search, selectedTags, sortNewest]);

  return (
    <div style={{ height: "100%", display:"flex", flexDirection: "column" }}>
      <div className="projectIntroCenter">
        <div className="column center" >
          <h1 className="">Projects</h1>
        </div>

          <div className="filteringProjects">
            {/* {console.log('flattened:', projectMeta.flatMap((p) => p.tags))
            } */}

            <FilterList 
            selectedTagz={selectedTags} 
            setselectedTags={setSelectedTags}/>

            {/* <SearchBar search={search} setSearch={setSearch} className='searchbar' /> */}
           
          </div>
          <button
            onClick={clearFilters}
            className="resetFilters"
          >
            Reset Filters
          </button>
      </div>
      <div className="segTwo" style={{ flex:1 }}>
        <Drawer isOpen={isOpen} className="drawer">

          {filtered.map((p) => (
            <div className="project">
              <Link
                to={p.path}
                key={p.id}
              >
                <img
                  src={process.env.PUBLIC_URL + p.image}
                  alt={p.title}
                />
                <h2>{p.title}</h2>
                <p style={{ paddingBottom: '10px'}}>{p.date}</p>
                <p>{p.description}</p>
              </Link>
            </div>
          ))}

        </Drawer>
      </div>
    </div>
  );
}
